import fastDeepEqual from 'fast-deep-equal';

export const deepEqual = fastDeepEqual;
